import { CompartmentViolation } from "./validateCompartmentProductPlacement";

type OrderedGood = {
  _id?: string | null;
  goodProfileId?: string | null;
  quantity: number;
};

type AssignmentInput = {
  commodityId: string;
  quantity: number;
};

/**
 * Flags a good placed into compartments beyond the amount that was ordered.
 *
 * Volumes can be overridden per compartment, so nothing else stops a user from
 * loading more than the order. An assignment stores the goodProfileId as its
 * commodityId, but some records use the good's own _id, so both are matched.
 */
export function validateAssignedQuantities(input: {
  orderedGoods: OrderedGood[];
  assignments: AssignmentInput[];
}): CompartmentViolation[] {
  const { orderedGoods, assignments } = input;
  const violations: CompartmentViolation[] = [];

  for (const good of orderedGoods) {
    const assigned = assignments
      .filter(
        (a) =>
          a.commodityId === good._id || a.commodityId === good.goodProfileId
      )
      .reduce((total, a) => total + (a.quantity || 0), 0);

    if (assigned > good.quantity) {
      violations.push({
        type: "OVER_ASSIGNED",
        commodityId: good._id || good.goodProfileId || "",
        assigned,
        ordered: good.quantity,
      });
    }
  }

  return violations;
}
